<template>
  <div class="input-page" ref="bgDom">
    <img src="../assets/inputTitle.png" class="input-title mid img-point"/>
    <div class="input-box mid">
      <div class="caret" v-show="caretShow"></div>
      <input  ref='inputDom' type='text' @blur="inputBlur" @focus="caretShow=false" class="input" v-model="name" placeholder=""/>
    </div>
    <img src="../assets/arrow.png" class="input-arrow mid img-point"/>
    <input type="button"  class="btn mid"  @click = "!clicked && checkInput()"/>
  </div>
</template>

<script>
  import {androidInputFixed} from '../utils'
export default {
  name: 'Input',
  data () {
    return {
      name: '',
      caretShow: true,
      clicked: false
    }
  },
  mounted() {
    const height = window.innerHeight
    androidInputFixed(height,this.$refs.bgDom,this.$refs.inputDom)
  },
  methods: {
    checkInput() {
      if (!this.$hasContent(this.name)) {
        alert('请输入姓名')
        return
      }
      if (this.$getRealLength(this.name) > 20) {
        alert('输入字数过多，请重新输入')
        return
      }
      if (this.$filterWord(this.name)) {
        alert('请检查输入')
        return
      }
      this.clicked = true
      const totalNum = 20
      const result = Math.ceil(Math.random()*totalNum)
      const src =  `./static/result/${result}.png`

      this.$preloadImg({
        src,
        isBg: true,
        name: 'bg'
      })
      this.$router.push( `/result?name=${this.name}`)
    },
    inputBlur() {
      this.caretShow = !this.name
      window.scrollTo(0,0)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
.input-page {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(../assets/inputBg.png) 0 0 / 100% 94% no-repeat #000;
}
.mid {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.input-title {
  width: 6rem;
  top: 18.6%;
}
.input-arrow {
  width: 0.15rem;
  animation: slideUpDown 2s linear infinite;
}
input {
  background: transparent;
  border: none;
  outline: none;
}
.input-box {
  top: 43.8%;
}
.input {
  display: block;
  width: 3.95rem;
  border: 1px solid rgb(174, 154, 102);
  box-shadow:0px 2px 5px 0px rgba(174, 154, 102,0.3);
  padding:0.2rem 0 0.2rem 3%;
  line-height: 1;
  box-sizing: border-box;
  color: #c4a974;
  font-size: 0.4rem;
  border-radius: 0;
  -webkit-appearance: none;
  caret-color:#c4a974;
}
.caret {
  position: absolute;
  top: 48%;
  left:3%;
  transform: translateY(-50%) ;
  height: 0.42rem;
  width: 1px;
  background-color: #c4a974;
  font-size: 0.4rem;
  animation: blink-caret .75s step-end infinite;
}
.btn {
  width: 2.94rem;
  height:0.84rem;
  top: 63.3%;
  background: url(../assets/btn_start.png) 0 0/contain no-repeat;
}

@keyframes slideUpDown {
  0% {
    top: 55.6%;
  }
  70% {
    top: 56.6%;
  }
  100% {
   top: 55.6%;
  }
}

@keyframes blink-caret {
  from, to { opacity: 0 }
  50% { opacity: 1}
}
</style>



// WEBPACK FOOTER //
// src/pages/Input.vue